const timeTableStyles = {
  /* ===== DESKTOP ===== */
  pageContainer: {
    padding: "50px 20px",
    maxWidth: 1100,
    margin: "0 auto",
  },

  heading: {
    textAlign: "center",
    color: "#111827",
    marginBottom: 40,
    fontWeight: 800,
    fontSize: 28,
  },

  loadingBox: {
    textAlign: "center",
    padding: 40,
    fontSize: 16,
    color: "#6b7280",
  },

  emptyState: {
    textAlign: "center",
    padding: 30,
    color: "#6b7280",
  },

  dayCard: {
    background: "#dbdee6ff",
    marginBottom: 22,
    borderRadius: 18,
    boxShadow: "0 14px 40px rgba(0,0,0,0.35)",
    overflow: "hidden",
  },

  dayHeader: {
    padding: "18px 22px",
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    fontWeight: 700,
    background: "linear-gradient(135deg, #028891ff, #028891ff)",
    transition: "all 0.3s ease",
  },

  dayHeaderExpanded: {
    background: "linear-gradient(135deg, #05a0abff, #03a3afff)",
  },

  dayHeaderHover: {
    background: "linear-gradient(135deg, #08b5c1ff, #0aaab6ff)",
  },

  dayHeaderText: {
    fontSize: 17,
    color: "#ffffff",
  },

  arrow: {
    marginLeft: "auto",
    fontSize: 14,
    color: "#ffffff",
    transition: "transform 0.3s ease",
  },

  sessionList: {
    padding: 22,
  },

  /* ===== MOBILE ===== */
  mobile: {
    pageContainer: {
      padding: "20px 12px",
    },

    heading: {
      fontSize: 18,
      marginBottom: 24,
      textAlign: "center",
      fontWeight: 800,
    },

    dayCard: {
      marginBottom: 16,
      borderRadius: 14,
      background: "#dbdee6ff",
      boxShadow: "0 8px 20px rgba(0,0,0,0.25)",
      overflow: "hidden",
    },

    dayHeader: {
      padding: "14px 16px",
      display: "flex",
      alignItems: "center",
      fontWeight: 700,
      background: "linear-gradient(135deg, #028891ff, #028891ff)",
    },

    dayHeaderText: {
      fontSize: 15,
      color: "#ffffff",
    },

    sessionList: {
      padding: 14,
    },
  },
};

export default timeTableStyles;
